import React, { lazy, Suspense } from 'react';

const ExpiredLinkComponent = lazy(() => import('./LinkExpired.component'));

const LazyExpiredLinkComponent = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <ExpiredLinkComponent {...props} />
  </Suspense>
);

export default LazyExpiredLinkComponent;
